export const projectData = {
  app: [
    {
      title: "Fitness Tracker App",
      category: "App Development",
      description:
        "A mobile app to track workouts, nutrition, and progress.  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, quaerat. Totam obcaecati tenetur temporibus, optio vitae maiores laboriosam laudantium atque.",
      image: [
        "/images/portfolio-1.png",
        "/images/portfolio-2.png",
        "/images/portfolio-3.png",
      ],
      tags: ["React Native", "Redux", "Firebase"],
    },
    {
      title: "Expense Manager App",
      category: "App Development",
      description:
        "An app to manage personal finances, track expenses, and set budgets.  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, quaerat. Totam obcaecati tenetur temporibus, optio vitae maiores laboriosam laudantium atque.",
      image: [
        "/images/portfolio-4.png",
        "/images/portfolio-5.png",
        "/images/portfolio-6.png",
      ],
      tags: ["Flutter", "Dart", "SQLite"],
    },
    {
      title: "Meditation App",
      category: "App Development",
      description:
        "A meditation and mindfulness app with guided sessions and breathing exercises.  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, quaerat. Totam obcaecati tenetur temporibus, optio vitae maiores laboriosam laudantium atque.",
      image: [
        "/images/portfolio-7.png",
        "/images/portfolio-8.png",
        "/images/portfolio-9.png",
      ],
      tags: ["Kotlin", "Coroutines", "Room"],
    },
    {
      title: "E-Learning App",
      category: "App Development",
      description:
        "An educational app offering courses, quizzes, and progress tracking.  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, quaerat. Totam obcaecati tenetur temporibus, optio vitae maiores laboriosam laudantium atque.",
      image: [
        "/images/portfolio-1.png",
        "/images/portfolio-2.png",
        "/images/portfolio-3.png",
      ],
      tags: ["Swift", "Combine", "CoreData"],
    },
    {
      title: "Travel Booking App",
      category: "App Development",
      description:
        "A travel booking app for flights, hotels, and holiday packages.  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, quaerat. Totam obcaecati tenetur temporibus, optio vitae maiores laboriosam laudantium atque.",
      image: [
        "/images/portfolio-4.png",
        "/images/portfolio-5.png",
        "/images/portfolio-6.png",
      ],
      tags: ["React Native", "GraphQL", "AWS"],
    },
    {
      title: "Recipe App",
      category: "App Development",
      description:
        "A recipe app with a collection of cooking recipes and meal planning features.  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, quaerat. Totam obcaecati tenetur temporibus, optio vitae maiores laboriosam laudantium atque.",
      image: [
        "/images/portfolio-7.png",
        "/images/portfolio-8.png",
        "/images/portfolio-9.png",
      ],
      tags: ["Flutter", "Firebase", "Firestore"],
    },
  ],
  game: [
    {
      title: "Puzzle Adventure Game",
      category: "Game Development",
      description:
        "An immersive puzzle adventure game with challenging levels and story-driven gameplay.  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, quaerat. Totam obcaecati tenetur temporibus, optio vitae maiores laboriosam laudantium atque.",
      image: [
        "/images/portfolio-1.png",
        "/images/portfolio-1.png",
        "/images/portfolio-3.png",
      ],
      tags: ["Unity", "C#", "Blender"],
    },
    {
      title: "Multiplayer Racing Game",
      category: "Game Development",
      description:
        "A fast-paced multiplayer racing game with customizable cars and tracks.  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, quaerat. Totam obcaecati tenetur temporibus, optio vitae maiores laboriosam laudantium atque.",
      image: [
        "/images/portfolio-4.png",
        "/images/portfolio-5.png",
        "/images/portfolio-6.png",
      ],
      tags: ["Blueprint", "Photoshop"],
    },
    {
      title: "2D Platformer",
      category: "Game Development",
      description:
        "A classic 2D platformer game with retro graphics and challenging levels.  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, quaerat. Totam obcaecati tenetur temporibus, optio vitae maiores laboriosam laudantium atque.",
      image: [
        "/images/portfolio-7.png",
        "/images/portfolio-8.png",
        "/images/portfolio-9.png",
      ],
      tags: ["Godot", "GDScript", "Aseprite"],
    },
    {
      title: "Virtual Reality Shooter",
      category: "Game Development",
      description:
        "A first-person shooter game designed for virtual reality headsets.  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, quaerat. Totam obcaecati tenetur temporibus, optio vitae maiores laboriosam laudantium atque.",
      image: [
        "/images/portfolio-1.png",
        "/images/portfolio-2.png",
        "/images/portfolio-3.png",
      ],
      tags: ["Unity", "C#", "Oculus SDK"],
    },
    {
      title: "Multiplayer Racing Game",
      category: "Game Development",
      description:
        "A fast-paced multiplayer racing game with customizable cars and tracks.  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, quaerat. Totam obcaecati tenetur temporibus, optio vitae maiores laboriosam laudantium atque.",
      image: [
        "/images/portfolio-1.png",
        "/images/portfolio-2.png",
        "/images/portfolio-3.png",
      ],
      tags: ["Unreal Engine", "Photoshop"],
    },
    {
      title: "2D Platformer",
      category: "Game Development",
      description:
        "A classic 2D platformer game with retro graphics and challenging levels.  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, quaerat. Totam obcaecati tenetur temporibus, optio vitae maiores laboriosam laudantium atque.",
      image: [
        "/images/portfolio-9.png",
        "/images/portfolio-9.png",
        "/images/portfolio-9.png",
      ],
      tags: ["Godot", "GDScript", "Aseprite"],
    },
    {
      title: "Virtual Reality Shooter",
      category: "Game Development",
      description:
        "A first-person shooter game designed for virtual reality headsets.  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, quaerat. Totam obcaecati tenetur temporibus, optio vitae maiores laboriosam laudantium atque.",
      image: [
        "/images/portfolio-1.png",
        "/images/portfolio-1.png",
        "/images/portfolio-1.png",
      ],
      tags: ["Unity", "C#", "Oculus SDK"],
    },
  ],
  web: [
    {
      title: "HRM Management Tool",
      category: "Web Development",
      description:
        "A comprehensive HRM tool for managing employee data, attendance, and performance.  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, quaerat. Totam obcaecati tenetur temporibus, optio vitae maiores laboriosam laudantium atque.",
      image: [
        "/images/portfolio-2.png",
        "/images/portfolio-2.png",
        "/images/portfolio-2.png",
      ],
      tags: ["React", "Node.js", "MongoDB"],
    },
    {
      title: "E-commerce Store",
      category: "Web Development",
      description:
        "An online store with a range of features including product browsing, cart, and checkout. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, quaerat. Totam obcaecati tenetur temporibus, optio vitae maiores laboriosam laudantium atque.",
      image: [
        "/images/portfolio-3.png",
        "/images/portfolio-3.png",
        "/images/portfolio-3.png",
      ],
      tags: ["Vue.js", "Express", "MySQL"],
    },
    {
      title: "Portfolio Website",
      category: "Web Development",
      description:
        "A personal portfolio website showcasing projects, blog posts, and contact information.  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, quaerat. Totam obcaecati tenetur temporibus, optio vitae maiores laboriosam laudantium atque.",
      image: [
        "/images/portfolio-4.png",
        "/images/portfolio-4.png",
        "/images/portfolio-4.png",
      ],
      tags: ["Gatsby", "GraphQL", "CSS"],
    },
    {
      title: "Blog Platform",
      category: "Web Development",
      description:
        "A content management platform for creating and managing blog posts and user comments.  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, quaerat. Totam obcaecati tenetur temporibus, optio vitae maiores laboriosam laudantium atque.",
      image: [
        "/images/portfolio-4.png",
        "/images/portfolio-4.png",
        "/images/portfolio-4.png",
      ],
      tags: ["Next.js", "Firebase", "Tailwind CSS"],
    },
    {
      title: "Knox Primary Care",
      category: "Web Development",
      description:
        "A modern, HIPAA-compliant website for Knox Primary Care Family Medicine clinic in West Knoxville, Tennessee. Features professional medical practice aesthetic with smooth animations, fully responsive design, and comprehensive clinic information including location, hours, patient registration, and insurance information.",
      image: [
        "/images/porfolio/knox1.png",
        "/images/porfolio/knox2.png",
        "/images/porfolio/knox3.png",
      ],
      tags: ["React", "TypeScript", "Tailwind CSS", "Framer Motion", "Firebase"],
      liveUrl: "https://knox-primary-care.vercel.app/insurance",
    },
    {
      title: "Kielo - Landing Page",
      category: "Web Development",
      description:
        "A single-page landing page for Kielo, embodying calm confidence, restraint, and permanence. Features elegant design with minimal color palette, brand presence, reservation details, and integrated Stripe Checkout functionality.",
      image: [
        "/images/porfolio/keilo1.png",
        "/images/porfolio/keilo2.png",
        "/images/porfolio/keilo3.png",
      ],
      tags: ["React", "TypeScript", "Tailwind CSS", "Vite", "Stripe"],
      liveUrl: "https://kielo.cc/",
    },
    {
      title: "Kamar International",
      category: "Web Development",
      description:
        "A professional website for Kamar International, a family textile manufacturing company. Features video hero section, product showcase, company history, and multilingual support. Built with Next.js for optimal performance and SEO.",
      image: [
        "/images/porfolio/kamar.png",
        "/images/porfolio/kamar2.png",
        "/images/porfolio/kamar3.png",
      ],
      tags: ["Next.js", "React", "TypeScript", "Tailwind CSS"],
      liveUrl: "https://www.kamarint.com/",
    },
    {
      title: "Beela - AI Voice Assistant",
      category: "Web Development",
      description:
        "A beautiful, modern coming soon landing page for Beela AI Voice Assistant. Features clean minimal design with smooth animations, email collection form for beta tester waitlist, and vibrant blue branding with custom robot logo design.",
      image: [
        "/images/porfolio/beela.png",
        "/images/porfolio/beela2.png",
        "/images/porfolio/beela.png",
      ],
      tags: ["React", "TypeScript", "Vite", "Tailwind CSS"],
      liveUrl: "https://beela-tau.vercel.app/",
    },
    {
      title: "LooView - Public Toilet Finder",
      category: "Web Development",
      description:
        "A Next.js application for rating and reviewing public toilets. Features Google Maps integration, photo uploads, AI-driven reviews, GPS auto-tagging, and a clean interface focused on hygiene and accessibility. Built with Firebase for real-time data and authentication.",
      image: [
        "/images/porfolio/looview1.png",
        "/images/porfolio/looview2.png",
        "/images/porfolio/looview3.png",
        "/images/porfolio/looview4.png",
        "/images/porfolio/looview5.png",
      ],
      tags: ["Next.js", "Firebase", "Google Maps API", "TypeScript", "Tailwind CSS"],
      liveUrl: "https://looview.io/",
    },
    {
      title: "Vesello - Wedding Invitation Platform",
      category: "Web Development",
      description:
        "A beautiful, modern wedding invitation and RSVP system. Features multi-step RSVP process, gallery management, admin dashboard for managing events and guests, secure authentication, and image storage integration. Built with Next.js 15, Supabase, and Bunny.net for fast image delivery.",
      image: [
        "/images/porfolio/vesello1.png",
        "/images/porfolio/vesello2.png",
        "/images/porfolio/vesello3.png",
        "/images/porfolio/vesello4.png",
        "/images/porfolio/vesello5.png",
      ],
      tags: ["Next.js", "React", "TypeScript", "Supabase", "Tailwind CSS", "Bunny.net"],
      liveUrl: "https://app.vesello.net/",
    },
    {
      title: "La Kahina",
      category: "Web Development",
      description:
        "A personal storytelling site and digital journal capturing travel, events, and memories. Built as a fast, content-driven blog with rich image galleries, responsive layouts, and smooth navigation.",
      image: [
        "/images/porfolio/lakahina1.png",
        "/images/porfolio/lakahina2.png",
        "/images/porfolio/lakahina3.png",
        "/images/porfolio/lakahina4.png",
      ],
      tags: ["Vite", "React", "TypeScript", "React Router", "Tailwind CSS"],
      liveUrl: "https://www.lakahina.world/",
    },
    {
      title: "Yedder World",
      category: "Web Development",
      description:
        "A modern e-commerce website built with Vite, React, and TypeScript. Features product listings, cart and checkout flows, and a responsive, performance-focused user experience.",
      image: [
        "/images/porfolio/yedder1.png",
        "/images/porfolio/yedder2.png",
        "/images/porfolio/yedder3.png",
        "/images/porfolio/yedder4.png",
      ],
      tags: ["Vite", "React", "TypeScript", "React Router"],
      liveUrl: "https://www.yedder.world/",
    },
    {
      title: "Sahar Camp",
      category: "Web Development",
      description:
        "A personal blog and memory archive for Sahar Camp, showcasing camp stories, experiences, and photo galleries with a clean, responsive layout and smooth navigation.",
      image: [
        "/images/porfolio/sahar1.png",
        "/images/porfolio/sahar2.png",
        "/images/porfolio/sahar3.png",
        "/images/porfolio/sahar4.png",
      ],
      tags: ["Vite", "React", "TypeScript", "React Router", "Tailwind CSS"],
      liveUrl: "https://www.saharcamp.com/",
    },
    {
      title: "Prospectra — AI Lead Generation",
      category: "Web Development",
      description:
        "An AI and RAG-powered lead generation platform that turns a single keyword into a spectrum of qualified leads. Automates prospect discovery, retrieves relevant context with retrieval-augmented generation, and surfaces actionable insights so teams can research markets and outreach faster.",
      image: [
        "/images/porfolio/prospectra.png",
      ],
      tags: ["AI", "RAG", "React", "TypeScript", "Lead Generation"],
      liveUrl: "https://prospectra-lead-generation-automati.vercel.app/",
    },
    {
      title: "Website RAG Chatbot",
      category: "Web Development",
      description:
        "An AI-powered RAG chatbot that answers questions from any website's content. Ingests site pages into a retrieval pipeline, grounds responses in retrieved context, and delivers accurate, source-aware answers for support, docs, and knowledge bases.",
      image: [
        "/images/porfolio/website-rag.png",
      ],
      tags: ["AI", "RAG", "Chatbot", "React", "TypeScript"],
      liveUrl: "https://website-rag-chat-bott.vercel.app/",
    },
  ],
  blockchain: [
    {
      title: "Crypto Wallet",
      category: "Blockchain",
      description:
        "A secure crypto wallet for managing and storing various cryptocurrencies.  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, quaerat. Totam obcaecati tenetur temporibus, optio vitae maiores laboriosam laudantium atque.",
      image: [
        "/images/portfolio-6.png",
        "/images/portfolio-6.png",
        "/images/portfolio-6.png",
      ],
      tags: ["Solidity"],
    },
    {
      title: "Decentralized Exchange",
      category: "Blockchain",
      description:
        "A decentralized exchange platform for trading cryptocurrencies.  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, quaerat. Totam obcaecati tenetur temporibus, optio vitae maiores laboriosam laudantium atque.",
      image: [
        "/images/portfolio-7.png",
        "/images/portfolio-7.png",
        "/images/portfolio-7.png",
      ],
      tags: ["Angular", "Ethereum", "Web3.js"],
    },
    {
      title: "NFT Marketplace",
      category: "Blockchain",
      description:
        "An online marketplace for buying and selling non-fungible tokens (NFTs).  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, quaerat. Totam obcaecati tenetur temporibus, optio vitae maiores laboriosam laudantium atque.",
      image: [
        "/images/portfolio-8.png",
        "/images/portfolio-7.png",
        "/images/portfolio-7.png",
      ],
      tags: ["Smart Contracts", "IPFS"],
    },
    {
      title: "Blockchain Voting System",
      category: "Blockchain",
      description:
        "A secure and transparent voting system based on blockchain technology.  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, quaerat. Totam obcaecati tenetur temporibus, optio vitae maiores laboriosam laudantium atque.",
      image: [
        "/images/portfolio-9.png",
        "/images/portfolio-9.png",
        "/images/portfolio-9.png",
      ],
      tags: ["React", "Hyperledger"],
    },
    {
      title: "NFT Marketplace",
      category: "Blockchain",
      description:
        "An online marketplace for buying and selling non-fungible tokens (NFTs).  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, quaerat. Totam obcaecati tenetur temporibus, optio vitae maiores laboriosam laudantium atque.",
      image: [
        "/images/portfolio-8.png",
        "/images/portfolio-7.png",
        "/images/portfolio-7.png",
      ],
      tags: ["Vue.js", "IPFS"],
    },
    {
      title: "Blockchain Voting System",
      category: "Blockchain",
      description:
        "A secure and transparent voting system based on blockchain technology.  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, quaerat. Totam obcaecati tenetur temporibus, optio vitae maiores laboriosam laudantium atque.",
      image: [
        "/images/portfolio-9.png",
        "/images/portfolio-9.png",
        "/images/portfolio-9.png",
      ],
      tags: ["React", "Hyperledger"],
    },
  ],
};

export const tagColors = {
  React: "bg-blue-100 text-blue-800",
  "Node.js": "bg-green-100 text-green-800",
  "Web3.js": "bg-green-100 text-green-800",
  MongoDB: "bg-orange-100 text-orange-800",
  "React Native": "bg-cyan-100 text-cyan-800",
  Redux: "bg-purple-100 text-purple-800",
  Firebase: "bg-red-100 text-red-800",
  Flutter: "bg-teal-100 text-teal-800",
  Angular: "bg-teal-100 text-teal-800",
  Dart: "bg-yellow-100 text-yellow-800",
  SQLite: "bg-pink-100 text-pink-800",
  Kotlin: "bg-red-100 text-red-800",
  Coroutines: "bg-pink-100 text-pink-800",
  Room: "bg-blue-100 text-blue-800",
  Swift: "bg-gray-100 text-gray-800",
  Combine: "bg-blue-100 text-blue-800",
  CoreData: "bg-green-100 text-green-800",
  Hyperledger: "bg-green-100 text-green-800",
  GraphQL: "bg-orange-100 text-orange-800",
  "Smart Contracts": "bg-orange-100 text-orange-800",
  AWS: "bg-cyan-100 text-cyan-800",
  Unity: "bg-purple-100 text-purple-800",
  Solidity: "bg-purple-100 text-purple-800",
  Ethereum: "bg-purple-100 text-purple-800",
  "C#": "bg-red-100 text-red-800",
  Blender: "bg-teal-100 text-teal-800",
  "Unreal Engine": "bg-yellow-100 text-yellow-800",
  Blueprint: "bg-pink-100 text-pink-800",
  Photoshop: "bg-cyan-100 text-cyan-800",
  Godot: "bg-purple-100 text-purple-800",
  IPFS: "bg-purple-100 text-purple-800",
  GDScript: "bg-yellow-100 text-yellow-800",
  Aseprite: "bg-gray-100 text-gray-800",
  Express: "bg-green-100 text-green-800",
  MySQL: "bg-blue-100 text-blue-800",
  Gatsby: "bg-purple-100 text-purple-800",
  "Tailwind CSS": "bg-cyan-100 text-cyan-800",
  Firestore: "bg-red-100 text-red-800",
  "Oculus SDK": "bg-indigo-100 text-indigo-800",
  "Framer Motion": "bg-pink-100 text-pink-800",
  "Google Maps API": "bg-red-100 text-red-800",
  "Bunny.net": "bg-purple-100 text-purple-800",
  Supabase: "bg-green-100 text-green-800",
  Stripe: "bg-indigo-100 text-indigo-800",
  AI: "bg-violet-100 text-violet-800",
  RAG: "bg-emerald-100 text-emerald-800",
  "Lead Generation": "bg-amber-100 text-amber-800",
  Chatbot: "bg-sky-100 text-sky-800",
};
